import React, { useEffect, useState } from "react"

import { Container, CardBody, Card } from "reactstrap"
//redux

import Breadcrumb from "components/Common/Breadcrumb"
import AllSingleItems from "../Single Item Master"
import { axiosbaseurl } from "configure"

const AllServiceMaster = () => {
  // document.title = "Service Master | Peacock Accountants Limited";

  const [clientTypes, setClientTypes] = useState([])

  useEffect(() => {
    // getting dropdown options common function
    ; (async () => {
      try {
        const response = await axiosbaseurl.get(`/client-type/active`)
        if (response.data.success) setClientTypes(response.data.data.sort((a, b) => a.clientType.localeCompare(b.clientType)))
      } catch (error) {
        console.log(error)
      }
    })()
  }, [])

  const serviceCategories = [
    {
      id: 1,
      name: "Billiable and scheduled",
    },
    {
      id: 2,
      name: "Billiable and Non-scheduled",
    },
    {
      id: 3,
      name: "Non-Billiable and scheduled",
    },
    {
      id: 4,
      name: "Non-Billiable and Non-scheduled",
    },
  ]

  return (
    <div>
      <div className="page-content mb-5">
        <Container fluid>
          <Breadcrumb title={"Dashboard"} breadcrumbItem={"Service Master"} />

          <Card className="px-0 mx-0">
            <CardBody>
              <AllSingleItems
                api_name={"service-master"}
                heading={"Service"}
                title={"Service Name"}
                fieldName={"serviceName"}
                clientTypes={clientTypes}
                serviceCategory={serviceCategories}
                module_id={6}
                isDelete={false}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </div>
  )
}

export default AllServiceMaster
